import { render, staticRenderFns } from "./ComprehensiveApproach.vue?vue&type=template&id=7d7afd85&scoped=true"
import script from "./ComprehensiveApproach.vue?vue&type=script&lang=js"
export * from "./ComprehensiveApproach.vue?vue&type=script&lang=js"
import style0 from "./ComprehensiveApproach.vue?vue&type=style&index=0&id=7d7afd85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7afd85",
  null
  
)

export default component.exports